export default __webpack_public_path__ + "static/media/eduGreen.3fe15544.svg";